module.exports = __webpack_public_path__ + "static/koi-9434fc1593c6dfa04304db47cfb93e74.png";